import { ACCOUNT_TYPE_STAFF } from "core/consts";
import Config, { ENV_PRODUCTION } from "core/model/config";
import { isPrintMode } from "core/model/utils/urls";
import lazy from "dsl/atoms/retry";
import { Suspense } from "react";
import { useLoggedInAccount } from "reduxentities/hooks";

const LanguageFab = lazy(() => import("./Fab"));

export default function LazyLanguageFab() {
  const isPrint = isPrintMode();
  const loggedAccount = useLoggedInAccount();

  const isStaff = loggedAccount?.account_type === ACCOUNT_TYPE_STAFF;

  if (isPrint || (Config.environment === ENV_PRODUCTION && !isStaff))
    return null;

  return (
    <Suspense fallback={<div />}>
      <LanguageFab />
    </Suspense>
  );
}
